/* @flow */
import * as React from 'react';

import { Box } from '@sonyged/proc-ui';
import styled from 'styled-components';

import { HEIGHT, SUSHI_HEIGHT } from './constants';
import { SushiContext } from '../../SushiContext';
import type { Sushi as SushiT } from '../../rules/types';

const SushiBase = styled(Box)(
  {
    position: 'absolute',
    top: 0,
    bottom: 0,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'auto 100%',
    width: '20%',
    height: `${(SUSHI_HEIGHT / HEIGHT) * 100}%`,
  },
  ({ backgroundImage }) => ({ backgroundImage })
);

type Props = {
  ...SushiT,
};

export function SushiDish(props: Props) {
  const { kind, subkind, ...rest } = props;
  const mapper = React.useContext(SushiContext);
  const bg = React.useMemo(() => `url('${mapper.getSushiDishImg({ kind, subkind })}')`, [mapper, kind, subkind]);
  return <SushiBase {...rest} backgroundImage={bg} />;
}

export function Sushi(props: Props) {
  const { kind, subkind, ...rest } = props;
  const mapper = React.useContext(SushiContext);
  const bg = React.useMemo(() => `url('${mapper.getSushiImg({ kind, subkind })}')`, [mapper, kind, subkind]);
  return (
    <>
      <SushiDish {...props} />
      <SushiBase {...rest} backgroundImage={bg} />
    </>
  );
}
